export default __webpack_public_path__ + "static/media/Priya_Kumari_Gupta_Resume.cb888424.pdf";